<template>
  <dx-data-grid
    ref="dataGridRef"
    :allow-column-reordering="true"
    :column-chooser="{ enabled: true, mode: 'select' }"
    :column-min-width="80"
    :columns="columns"
    :data-source="dataSource"
    :filter-panel="{ visible: true }"
    :filter-row="{ visible: true }"
    :header-filter="{ visible: true }"
    :height="50"
    :hover-state-enabled="true"
    :remote-operations="true"
    :row-alternation-enabled="true"
    :show-borders="true"
    :show-column-lines="true"
    :width="'100%'"
    :word-wrap-enabled="true"
    style="flex-grow: 1"
    @toolbar-preparing="onToolbarPreparing($event)"
    @content-ready="onContentReady($event)"
  >

    <dx-paging :enabled="true" :page-size="30" />
    <dx-load-panel :enabled="true" />
    <dx-scrolling mode="virtual" />
    <dx-sorting mode="single" />
    <dx-export :allow-export-selected-data="true" :enabled="true" :formats="['pdf', 'excel']" />

  </dx-data-grid>

  <footer-grid :totalCount="totalCount"></footer-grid>

</template>

<script>
export default {
  name: 'mped-amortization-upload-view-view',
};
</script>

<script setup>
import { onMounted, ref } from 'vue';
import {
  DxDataGrid,
  DxScrolling,
  DxLoadPanel,
  DxSorting,
  DxExport,
  DxPaging
} from 'devextreme-vue/data-grid';

import FooterGrid from '@/components/grid-card-component/footer-grid.vue';

import { getAiToolbar } from '@/components/utils/ai-toolbar-generator';
import { getAiDataSource } from '@/components/utils/ai-data-source-generator';
import {
  getUploadedViewData
} from '@/views/mped/services/mped-amortization-api-service';
import {
  columnsAmortizationUploadView,
} from '@/views/mped/services/mped-calculation-service';
import { initState, setLocalUserdata } from '@/service/local-userdata-service';
import { useRouter } from 'vue-router';


const
  totalCount = ref(0),
  columns = columnsAmortizationUploadView,
  dataGridRef = ref(),
  router = useRouter();

const dataSource = getAiDataSource(
  {
    dataFn: getUploadedViewData,
    key: 'id',
    remoteOperation: true,
    validationFn: () => {
      return true;
    },
    onLoadedFn: (data) => {
      totalCount.value = data.totalCount;
    },
    defaultDescSort: false,
    columns,
    dateFields: ['updated_at']
  },
);

onMounted(async () => {
  initState(router, dataGridRef);
});

const onToolbarPreparing = (e) => {
  getAiToolbar(e, {
    refresh: {
      event: reloadData,
    },
  });
};

const reloadData = () => {
  dataSource.reload();
};

const onContentReady = (e) => {
  setLocalUserdata(router, dataGridRef);
}

</script>

<style scoped>

</style>
